export default __webpack_public_path__ + "static/media/instagram.7b33ce47.svg";